<template>
<div class="flex flex-col">
  <!-- Logo -->
  <img v-if="isMobile" :src="company.Logo" style="width: 150px" class="mb-4" />
  <!-- End of Logo -->
  <!-- Header -->
  <div class="flex mb-8 md:mb-16">
    <div class="flex-1 flex-col md:flex-row">
      <h5 class="has-text-primary text-lg md:text-4xl font-bold">
      Hi {{user.Name + '!'}}
      </h5>
      <p class="text-lg hidden md:block">Selamat datang di iPOST</p>
      <p class="text-lg md:hidden">Silakan pilih kebutuhan Anda</p>
    </div>
    <div v-if="!isMobile" class="items-center flex">
      <mascot-avatar width="60px" height="60px" class="mr-2"></mascot-avatar>
      <div class="flex flex-col">
        <div class="font-bold text-xl">Account</div>
          <b-button size="is-small" type="is-info" class="text-xl" @click="signOut">Sign out</b-button>
        </div>
    </div>
  </div>
  <!-- End of Header -->
  <!-- Content -->
  <div class="flex-1">
   <div class="flex grid-cols-2 gap-4 mb-8">
      <mascot-card
        id="dashboard_warehouse_card"
        :img="warehouseMascotImg"
        class="has-background-primary text-white"
        title="Pengiriman Luar Negeri"
      >
        <p class="text-sm md:text-base">Dapatkan alamat gudang kami disini</p>
        <div class="grid grid-cols-2 gap-4 mt-2" :style="!isMobile ? 'width: 420px !important;' : 'width: 165px !important;'">
          <div class="flex">
            <div v-for="warehouse in warehouses" :key="warehouse.Oid" class="flex items-center cursor-pointer mt-2 pr-10" @click="showAddressDetail(warehouse)">
                <img :src="warehouse.Icon" class="mr-1 md:mr-4" style="width: 24px; height: auto" />
                <span class="text-xs mb:text-xl">{{warehouse.Text}}</span>
            </div>
           </div>
        </div>
      </mascot-card>
      <mascot-card
        :img="jastipMascotImg"
        id="dashboard_jastip_card"
        class="has-background-primary text-white"
        title="JASTIP"
        :left-offset="0.05"
        :mobile-left-offset="0.1"
      >
        <div v-if="isMobile" class="mb-5"></div>
        <p class="text-sm md:text-base mb-2">Ribet belanja sendiri? Serahkan saja kepada kami</p>
        <b-button type="is-white" class="has-text-primary" @click="showOrderModal">ORDER</b-button>
      </mascot-card>
    </div>
    <!-- Mobile tour card -->
    <tour-card v-if="isMobile" @click="$refs.mobileTour.start()"></tour-card>
    <!-- End of mobile tour card -->
    <!-- <p class="text-lg mt-4 mb-2">Tutorial menggunakan iPOST</p> -->
    <div :class="['grid gap-4 auto-rows-fr mb-8', {
      'grid-cols-5 mb-4': this.isMobile,
      'grid-cols-10 mt-0': !this.isMobile
    }]">
      <div :class="this.isMobile ? 'col-span-3' : 'col-span-5'">
        <video-card
          :thumb="videoThumb"
          :video="videoUrl">
        </video-card>
      </div>
        <calculator-card id="cost_calculator_card" :class="this.isMobile ? 'col-span-2' : 'col-span-2'"></calculator-card>
        <contact-card class="col-span-3" v-if="!isMobile"></contact-card>
    </div>
    <contact-card v-if="isMobile" class="mb-4"></contact-card>
    <div :class="['grid gap-4', { 'grid-cols-1': this.isMobile, 'grid-cols-1': !this.isMobile }]">
      <visit-us-card :class="{'col-span-1': this.isMobile, 'col-span-7': !this.isMobile }" :url="websiteUrl"></visit-us-card>
    </div>
  </div>
  <!-- End of Content -->

  <!-- Modals -->
  <warehouse-modal v-bind="modalProps('addressdetail')" @close="closeModal('addressdetail')">
  </warehouse-modal>
  <!-- End of Modals -->

  <b-modal v-model="orderModal" :width="300">
      <div class="card">
        <div class="card-content">
          <p class="text-center mb-4">Tambahkan list detail barang anda</p>
          <div class="flex justify-center">
            <router-link :to="{ path: '/proxy', query: { initial_form_type: 'form' } }">
              <b-button type="is-primary" class="mr-4">+Form</b-button>
            </router-link>
            <router-link :to="{ path: '/proxy', query: { initial_form_type: 'link' } }">
              <b-button type="is-primary">+Link</b-button>
            </router-link>
          </div>
        </div>
      </div>
  </b-modal>
  <tour v-if="isMobile" :scenes="mobileTourScenes" ref="mobileTour" storage-key="tour"></tour>
</div>
</template>

<script>
import CMSPage from '../../base/CMSPage'
import Tour from '@/components/vaddress/Tour'

const mobileTourScenes = [{
  elementId: 'dashboard_warehouse_card',
  anchor: 'bottom'
}, {
  elementId: 'dashboard_jastip_card',
  anchor: 'bottom'
}, {
  elementId: 'cost_calculator_card',
  anchor: 'top'
}, {
  elementId: 'ipost-mobilefooter',
  anchor: 'top'
}, {
  elementId: 'ipost-mobilefooter',
  anchor: 'top'
}, {
  elementId: 'ipost-mobilefooter',
  anchor: 'top'
}]

export default {
  extends: CMSPage,
  components: {
    MascotCard: () => import('./components/MascotCard'),
    VideoCard: () => import('./components/VideoCard'),
    CalculatorCard: () => import('./components/CalculatorCard'),
    ContactCard: () => import('./components/ContactCard'),
    VisitUsCard: () => import('./components/VisitUsCard'),
    TourCard: () => import('./components/TourCard'),
    WarehouseModal: () => import('./WarehouseModal'),
    MascotAvatar: () => import('@/components/vaddress/MascotAvatar'),
    Tour
  },
  data () {
    return {
      orderModal: false
    }
  },
  mounted () {
    document.title = 'iPOST - Jasa Kirim Barang Luar Negri - Indonesia'
    const dashboardTour = localStorage.getItem('tour1')
    if (!dashboardTour) this.startTour()
  },
  methods: {
  //   open (l) {
  //     this.openModal('address', {
  //       url: `/user/dashboard/addresses?CountryOid=${l.Oid}`
  //     })
  //   },
    showAddressDetail (d) {
      this.openModal('addressdetail', {
        url: `/user/dashboard/address?WarehouseId=${d.Oid}`
      })
    },
  //   copy ({ action, data }) {
  //     this.copyText(action._TextToCopy)
  //     .then((res) => {
  //       alert(`${data.Title} copied`)
  //     })
  //     .catch(() => {
  //       alert(`Failed to copy ${data.Title}`)
  //     })
  //   },
  //   getChatProps (d) {
  //     return {
  //       ...d,
  //       FooterActions: d.FooterActions.map((a) => {
  //         if (a.Id === 'chatbutton') {
  //           const { room } = this.$store.state.socket
  //           if (room && room.Unseen) {
  //             a.Badge = {
  //               Type: 'is-danger',
  //               Value: room.Unseen
  //             }
  //           }
  //         }
  //         return a
  //       })
  //     }
  //   },
  //   handleAction ({ action: a }) {
  //     if (a.Id === 'signout') {
  //       this.$buefy.dialog.confirm({
  //         message: this.config.LogoutMessage,
  //         type: 'is-primary',
  //         onConfirm: async () => {
  //           this.logout()
  //         }
  //     })
  //     }
  //   }
  showOrderModal () {
    this.orderModal = true
  },
  signOut () {
    this.$buefy.dialog.confirm({
          message: 'Apakah anda yakin untuk keluar?',
          type: 'is-primary-gradient',
          cancelText: 'Batal',
          confirmText: 'Ok',
          onConfirm: async () => {
            this.logout()
          }
      })
  },
  startTour () {

  }
  },
  computed: {
    videoUrl () {
      return this.response.VideoURL
    },
    videoThumb () {
      return this.response.VideoThumb
    },
    warehouses () {
      return this.response.Warehouses
    },
    websiteUrl () {
      return this.response.WebsiteUrl
    },
    mobileTourScenes () {
      const { MobileTours } = this.company
      return mobileTourScenes.map((scene, index) => ({
        ...scene,
        img: MobileTours[index]
      }))
    },
    warehouseMascotImg () {
      return this.company.MascotImages.Warehouse
    },
    jastipMascotImg () {
      return this.company.MascotImages.Jastip
    }
  }
}
</script>

<style>

</style>
